import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'
const quantity = {
  name: 'quantity',
  title: '完善形象工程量及清单复核量',
  width: '70%',
  rowData: (params) => {
    const progressItems = params.state.division.progressItemType
    progressItems.forEach((item) => {
      item.children = item.listHook
    })
    return progressItems
  },
  columns: [
    {
      prop: 'codeName',
      label: '\xa0\xa0\xa0形象进度分项&&清单细目',
      minWidth: '280px',
      align: 'left',
      overflow: false,
      overflowWidth: true
    },
    { prop: 'unit', width: '100px', label: '单位' },
    {
      prop: 'price',
      label: '单价(元)',
      width: '100px',
      formItem: () => {
        return (row) => {
          return !row.children
            ? {
                type: 'input'
              }
            : null
        }
      },
      number: 2
    },
    {
      prop: 'imageQuantity',
      label: '形象工程量',
      formItem: (params) => {
        return (row) => {
          const sizes = JSON.parse(
            JSON.stringify(params.state.division.structureSize.sizes)
          )
          return row.children
            ? {
                type: 'select',
                options: sizes.filter((item) => {
                  item.label = item.value
                  return item.value
                }),
                filterable: true,
                create: true,
                checkByValue: true,
                optionCustom: true,
                customKey: 'valueUint'
              }
            : null
        }
      },
      number: true
    },
    {
      prop: 'billCheckQuantity',
      label: '清单复核量',
      formItem: (params) => {
        return (row) => {
          const sizes = JSON.parse(
            JSON.stringify(params.state.division.structureSize.sizes)
          )
          return !row.children
            ? {
                type: 'select',
                options: sizes.filter((item) => {
                  item.label = item.value
                  return item.value
                }),
                filterable: true,
                create: true,
                checkByValue: true,
                optionCustom: true,
                customKey: 'valueUint'
              }
            : null
        }
      },
      number: true
    },
    {
      prop: 'drawingNo',
      label: '图纸编号',
      formItem: () => {
        return (row) => {
          return !row.children
            ? {
                type: 'input'
              }
            : null
        }
      }
    },
    {
      prop: 'marker',
      label: '备注',
      formItem: () => {
        return (row) => {
          return !row.children
            ? {
                type: 'input'
              }
            : null
        }
      },
      overflow: true
    }
  ]
}
const structureSize = {
  name: 'structureSize',
  title: '完善结构尺寸',
  formParams: (params) => {
    var formParams = {}
    if (params.step === 'divisionList') {
      formParams = params.state.currentRow.division
        ? params.state.currentRow.division.structureSize
        : {}
    } else {
      formParams = params.state.formValues.division
        ? params.state.formValues.division.structureSize
        : {}
    }
    if (!formParams.fileLists) {
      formParams.fileLists = {
        image: []
      }
    }
    if (formParams.sizes) {
      formParams.sizes.forEach((item) => {
        formParams[item.key] = item.value
      })
    } else {
      formParams.sizes = []
    }
    return formParams
  },
  formRules: {
    structureModel: [
      {
        required: true,
        message: '请选择结构模型',
        trigger: 'blur'
      }
    ]
  },
  formData: (params) => {
    var formData = [
      {
        key: 'structureModel',
        label: '结构模型',
        type: 'select',
        options: (params) => {
          return params.orgFields.structureModel
        }
      },
      {
        key: 'image',
        label: '模型图',
        type: 'upload',
        disabled: true,
        span: 24
      }
    ]
    if (params.formValues && params.formValues.sizes) {
      params.formValues.sizes.forEach((item, index) => {
        let size = {}
        size.key = item.key
        size.label = item.label
        size.type = 'input'
        size.inputButton = item.unit
        formData.splice(index + 1, 0, size)
      })
      if (params.formValues.sizes.length % 2 !== 1) {
        formData[0].span = 24
      }
    }

    return formData
  }
}
const division = {
  division: {
    name: 'division',
    componentTypes: [
      'navigate',
      'check',
      'tables',
      'stepForm',
      'drawerTable',
      'dialogForm',
      'dialogTable'
    ],
    headButtons: setCheckButtons(['新增单位工程']),
    queryFun: 'division/getSubitemList',
    getListFun: 'division/getSubitemList',
    addFun: 'division/addSubitem',
    editFun: 'division/editSubitemInfo',
    deleteFun: 'division/deleteSubitem',
    detailPage: [
      {
        buttonName: '新增单位工程',
        type: 'stepForm',
        name: 'division',
        theme: 'division',
        step: 'divisionInfo',
        label: '新增分部分项工程',
        pageStatus: 'addTop'
      },
      {
        buttonName: '新增下级',
        type: 'stepForm',
        name: 'division',
        theme: 'division',
        step: 'divisionInfo',
        label: '新增分部分项工程',
        pageStatus: 'addSub'
      },
      {
        buttonName: '编辑',
        type: 'stepForm',
        name: 'division',
        checkType: 'checkByUid',
        checkFun: 'division/getSubitemInfo',
        theme: 'division',
        step: 'divisionInfo',
        label: '编辑分部分项工程'
      },
      {
        buttonName: '复制',
        type: 'dialogForm',
        name: 'copySubitem'
      },
      {
        code: 'progressItem',
        type: (params) => {
          return params.currentRow &&
            params.currentRow.subitemLevel === 'subitemProType'
            ? 'tables'
            : 'expand'
        },
        name: (params) => {
          return params.currentRow &&
            params.currentRow.subitemLevel === 'subitemProType'
            ? 'progressItem'
            : 'division'
        },
        checkType: 'checkByUid',
        checkFun: 'division/getSubitemInfo',
        theme: 'division',
        step: 'progressItemList',
        label: '工程划分详情',
        expandAll: (params) => {
          return params.currentRow &&
            params.currentRow.subitemLevel === 'subitemProType'
            ? true
            : false
        }
      },
      {
        buttonName: '工程结构数据',
        type: (params) => {
          return params.currentRow &&
            params.currentRow.subitemLevel !== 'subitemProType'
            ? 'expand'
            : params.currentRow && params.currentRow.progressItemNum
            ? 'dialogForm'
            : ''
        },
        name: (params) => {
          return params.currentRow &&
            params.currentRow.subitemLevel === 'subitemProType'
            ? 'structureSize'
            : 'division'
        }
      },
      {
        buttonName: '添加起讫桩号',
        type: 'dialogForm',
        name: 'startEndStake'
      },
      {
        buttonName: '修改工程名称',
        type: 'dialogForm',
        name: 'subitemCN'
      },
      {
        buttonName: '完善结构尺寸',
        type: 'dialogForm',
        name: 'structureSize'
      },
      {
        buttonName: '完善工程数量',
        type: 'dialogTable',
        name: 'quantity',
        expandAll: true
      }
    ],
    outListHeight: 230,
    tagInfo:
      '复制工程默认复制选中分部分项工程信息添加在与其上一级工程同级别同类型的分部分项下。复制工程后注意部分分部分项编号、名称、起讫桩号是否正确，不正确可通过编辑操作修改。',
    rowData: (params) => {
      return params.state.division.subitemList
    },
    columns: [
      {
        prop: 'subitemCN',
        label: '\xa0\xa0\xa0分部分项编码/分部分项名称',
        align: 'left',
        width: '460px',
        overflowWidth: '80px'
      },
      { prop: 'subitemType', label: '分部分项类型', width: '150px' },
      {
        prop: 'jobManageInfo',
        label: '作业管理信息',
        width: '205px',
        overflow: false
      },
      {
        prop: 'progressItem',
        label: '工程划分信息',
        overflow: false,
        drillDown: true,
        tooltip: () => {
          return (row) => {
            return row.subitemLevel === 'subitemProType'
              ? { tipValue: '点击查看工程划分详情' }
              : null
          }
        }
      },
      {
        prop: 'structureData',
        label: '工程结构数据',
        width: '',
        overflow: false,
        drillDown: true,
        tooltip: () => {
          return (row) => {
            return row.subitemLevel === 'subitemProType'
              ? { tipValue: '点击查看工程结构数据' }
              : null
          }
        }
      },
      {
        label: '操作',
        width: '320px',
        buttons: setTableButtons(['新增下级', '编辑', '删除', '复制'])
      }
    ],
    formParams: {
      uid: '',
      orgUid: (params) => {
        return params.orgValue
      },
      parentUid: (params) => {
        return params.pageStatus === 'addSub'
          ? params.currentRow.uid
          : params.orgValue
      },
      parentCN: (params) => {
        return params.pageStatus === 'addSub'
          ? params.currentRow.subitemCN
          : params.orgName
      },
      subitemLevel: (params) => {
        return params.pageStatus === 'addTop'
          ? 'singieProType'
          : params.currentRow.subitemLevel === 'singieProType'
          ? 'subprojectType'
          : 'subitemProType'
      },
      parentTypeUid: (params) => {
        var projectType = params.dictionarys.projectConfig
          ? params.dictionarys.projectConfig.find((item) => {
              return params.getters['user/projectType'] === item.label
            })
          : {}
        return params.pageStatus === 'addSub'
          ? params.currentRow.subitemTypeUid
          : projectType
          ? projectType.value
          : ''
      },
      subitemTypeuid: '',
      subitemType: '',
      subitemCode: '',
      lineCode: '',
      startStake: '',
      endStake: '',
      centerStake: '',
      startEndStake: '',
      projectNo: '',
      subitemName: '',
      startEndStakes: [],
      subitemCNs: [],
      workAreaUid: (params) => {
        return params.state.organization.orgFactory &&
          params.state.organization.orgFactory[0]
          ? params.state.organization.orgFactory[0].value
          : ''
      },
      structureData: '',
      structureSize: {},
      structureModel: '',
      sizes: [],
      progressItems: [],
      concealedWorks: [],
      listHook: [],
      riskWorkTypes: []
    },
    formRules: (params) => {
      var formRules = {}
      if (params.pageStatus === 'addTop' || params.pageStatus === 'addSub') {
        formRules = {
          subitemTypeName: [
            {
              required: true,
              message: '请选择新增工程类型',
              trigger: 'blur'
            }
          ],
          startEndStakes: [
            {
              type: 'array',
              required: true,
              message: '请至少选择一个起讫桩号',
              trigger: 'change'
            }
          ],
          subitemCNs: [
            {
              type: 'array',
              required: true,
              message: '请至少添加一个分部分项名称',
              trigger: 'blur'
            }
          ]
        }
      } else if (params.pageStatus === 'edit') {
        formRules = {
          lineCode: [
            {
              required: params.getters['user/projectType'] === '公路工程',
              message: '请输入至少一个大写英文字母',
              trigger: 'blur'
            },
            {
              pattern: /^[A-Z]+$/g,
              message: '请输入至少一个大写英文字母',
              trigger: 'blur'
            }
          ],
          centerStake: [
            {
              required: params.getters['user/projectType'] === '公路工程',
              message: '请输入起始桩号',
              trigger: 'blur'
            },
            {
              pattern: /^\d+(\.\d{1,3})?$/g,
              message: '请输入数字,如果为小数则小数点后保留三位',
              trigger: 'blur'
            },
            {
              validator: (params) => {
                return params.validate.validateStake
              },
              trigger: 'blur'
            }
          ],
          startStake: [
            {
              required: params.getters['user/projectType'] === '公路工程',
              message: '请输入起始桩号',
              trigger: 'blur'
            },
            {
              pattern: /^\d+(\.\d{1,3})?$/g,
              message: '请输入数字,如果为小数则小数点后保留三位',
              trigger: 'blur'
            },
            {
              validator: (params) => {
                return params.validate.validateStake
              },
              trigger: 'blur'
            }
          ],
          endStake: [
            {
              required: params.getters['user/projectType'] === '公路工程',
              message: '请输入终止桩号',
              trigger: 'blur'
            },
            {
              pattern: /^\d+(\.\d{1,3})?$/g,
              message: '请输入数字,如果为小数则小数点后保留三位',
              trigger: 'blur'
            },
            {
              validator: (params) => {
                return params.validate.validateStake
              },
              trigger: 'blur'
            }
          ],
          subitemCode: [
            {
              required: true,
              message: '请输入分部分项编码',
              trigger: 'blur'
            }
          ],
          subitemName: [
            {
              required: true,
              message: '请输入分部分项名称',
              trigger: 'blur'
            }
          ]
        }
      }
      return formRules
    },
    formData: (params) => {
      var formData = {}
      formData = {
        card: '分部分项工程信息',
        bottomButtons: setFormButtons(['取消', '提交']),
        fields: [
          {
            key: 'parentCN',
            label: '上一级工程',
            type: 'input',
            disabled: true
          },
          {
            key: 'subitemLevel',
            label:
              params.pageStatus === 'addTop' || params.pageStatus === 'addSub'
                ? '新增工程级别'
                : params.pageStatus === 'edit'
                ? '分部分项级别'
                : null,
            type: 'select',
            options: params.dictionarys.subitemLevel,
            disabled: true,
            checkByValue: true
          },
          {
            key:
              params.pageStatus === 'addTop' || params.pageStatus === 'addSub'
                ? 'subitemTypeName'
                : null,
            label: '新增工程类型',
            type: 'select',
            options: params.state.division.subitemType,
            optionCustom: true,
            customKey: 'divideRule',
            valueKey: 'value',
            bindKeys: ['subitemUid', 'subitemType'],
            formKeys: ['subitemTypeUid', 'subitemType']
          },
          {
            key: params.pageStatus === 'edit' ? 'subitemType' : null,
            label: '分部分项类型',
            type: 'input',
            disabled: true
          },
          {
            key:
              params.pageStatus === 'edit' &&
              params.getters['user/projectType'] === '公路工程'
                ? 'lineCode'
                : null,
            label: '线路编号',
            type: 'input'
          },
          {
            key:
              params.pageStatus === 'edit' &&
              params.getters['user/projectType'] === '公路工程'
                ? 'centerStake'
                : null,
            label: '中心桩号',
            type: 'input',
            disabled: true
          },
          {
            key:
              params.pageStatus === 'edit' &&
              params.getters['user/projectType'] === '公路工程'
                ? 'startStake'
                : null,
            label: '起始桩号',
            type: 'input',
            number: 3
          },
          {
            key:
              params.pageStatus === 'edit' &&
              params.getters['user/projectType'] === '公路工程'
                ? 'endStake'
                : null,
            label: '终止桩号',
            type: 'input',
            number: 3
          },
          {
            key: params.pageStatus === 'edit' ? 'startEndStake' : null,
            label: '起讫桩号',
            type: 'input',
            disabled: true
          },
          {
            key: params.pageStatus === 'edit' ? 'projectNo' : null,
            label: '工程编号',
            type: 'input',
            placeholder: '请输入项目管理自定义编号名称，替换名称中起讫桩号'
          },
          {
            key:
              (params.pageStatus === 'addTop' ||
                params.pageStatus === 'addSub') &&
              params.getters['user/projectType'] === '公路工程'
                ? 'startEndStakes'
                : null,
            label: '起讫桩号',
            type: 'select',
            options: params.state.startEndStakes,
            placeholder:
              '请在已有的起讫桩号选项中选择，如没有请先按要求添加选项,可连续添加多段',
            multiple: true,
            valueKey: 'value',
            check: '添加起讫桩号'
          },
          {
            key: params.pageStatus === 'edit' ? 'subitemCode' : null,
            label: '分部分项编码',
            type: 'input'
          },
          {
            key: params.pageStatus === 'edit' ? 'subitemName' : null,
            label: '分部分项名称',
            type: 'input'
          },
          {
            key:
              params.pageStatus === 'addTop' || params.pageStatus === 'addSub'
                ? 'subitemCNs'
                : null,
            label: '分部分项名称',
            type: 'select',
            options: params.state.subitemCNs,
            placeholder:
              '根据上级名称、分部分项类别、起讫桩号等自动生成，可根据实际名称修改',
            disabled: true,
            multiple: true,
            valueKey: 'value',
            check: '修改工程名称'
          },
          {
            key:
              params.pageStatus !== 'addTop' &&
              params.formValues &&
              params.formValues.subitemLevel === 'subitemProType'
                ? 'workAreaUid'
                : null,
            label: '所属场站工区',
            type: 'select',
            options: params.state.organization.orgFactory,
            checkByValue: true,
            clearable: true
          },
          {
            key:
              params.pageStatus !== 'addTop' &&
              params.state.division.progressItemType.length &&
              params.formValues &&
              params.formValues.subitemLevel === 'subitemProType'
                ? 'structureData'
                : null,
            label: '结构尺寸数据',
            type: 'input',
            inputType: 'textarea',
            placeholder: '根据设计图纸完善结构尺寸数据',
            readonly: true,
            autosize: true,
            check: '完善结构尺寸'
          },
          {
            key:
              params.pageStatus === 'addSub' &&
              params.state.division.progressItemType.length &&
              params.formValues &&
              params.formValues.subitemLevel === 'subitemProType'
                ? 'progressItems'
                : null,
            label: '进度分项类型',
            type: 'select',
            options: params.state.division.progressItemType,
            placeholder: '根据新增工程类型选项变化自动按规则生成',
            inputTip:
              '按默认关联规则确定选项范围，如需添加范围外分项通过列表中下钻编辑工程划分信息',
            multiple: true,
            valueKey: 'value',
            check: '完善工程数量'
          },
          {
            key:
              params.pageStatus === 'addSub' &&
              params.state.division.progressItemType.length &&
              params.formValues &&
              params.formValues.subitemLevel === 'subitemProType'
                ? 'listHook'
                : null,
            label: '清单工程量',
            type: 'select',
            options: params.state.division.listHook,
            placeholder: '根据新增工程类型选项变化自动按规则生成',
            multiple: true,
            valueKey: 'value'
          },
          {
            key:
              params.pageStatus === 'addSub' &&
              params.state.division.progressItemType.length &&
              params.formValues &&
              params.formValues.subitemLevel === 'subitemProType'
                ? 'concealedWorks'
                : null,
            label: '隐蔽工程工序',
            type: 'select',
            options: params.state.division.concealedWorks,
            placeholder: '根据新增工程类型选项变化自动按规则生成',
            multiple: true,
            valueKey: 'value'
          },
          {
            key:
              params.pageStatus !== 'addTop' &&
              params.state.division.riskWorks.length &&
              params.formValues &&
              params.formValues.subitemLevel === 'subitemProType'
                ? 'riskWorkTypes'
                : null,
            label: '涉及风险作业',
            type: 'select',
            options: params.state.division.riskWorks,
            placeholder: '根据新增工程类型选项变化自动按规则生成',
            multiple: true,
            checkByValue: true
          }
        ]
      }
      return formData
    },
    copySubitem: {
      name: 'copySubitem',
      title: '复制分部分项工程',
      formParams: {
        subitemCN: (params) => {
          return params.state.currentRow.division
            ? params.state.currentRow.division.subitemCN
            : ''
        },
        subitemLevel: (params) => {
          return params.state.currentRow.division
            ? params.state.currentRow.division.subitemLevel
            : ''
        },
        parents: []
      },
      formRules: {
        parents: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个目标上级工程',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'subitemCN',
          label: '复制工程名称',
          type: 'input',
          disabled: true,
          span: 18
        },
        {
          key: 'subitemLevel',
          label: '复制工程级别',
          type: 'select',
          options: (params) => {
            return params.dictionarys.subitemLevel
          },
          disabled: true,
          checkByValue: true,
          span: 18
        },
        {
          key: 'parents',
          label: '目标上级工程',
          type: 'select',
          options: (params) => {
            var parentProjects = []
            const code =
              params.state.currentRow.division &&
              params.state.currentRow.division.subitemCode
                ? params.state.currentRow.division.subitemCode.slice(0, 1)
                : ''
            if (
              code &&
              params.state.currentRow.division.subitemLevel === 'singieProType'
            ) {
              parentProjects = [
                {
                  value: params.orgValue,
                  uid: params.orgValue,
                  label: params.getters['user/orgName'],
                  subitemTypeUid: '1'
                }
              ]
            } else if (
              code &&
              params.state.currentRow.division.subitemLevel === 'subprojectType'
            ) {
              parentProjects = params.state.division.subitemList.filter(
                (item) => {
                  return item.subitemCode.slice(0, 1) === code
                }
              )
            } else if (
              code &&
              params.state.currentRow.division.subitemLevel === 'subitemProType'
            ) {
              parentProjects = params.state.division.subprojects.filter(
                (item) => {
                  return (
                    item.subitemCode.slice(0, 1) === code &&
                    params.state.currentRow.division.parentTypeUid ===
                      item.subitemTypeUid
                  )
                }
              )
            }
            return parentProjects
          },
          valueKey: 'value',
          multiple: true,
          clearable: true,
          emitPath: false,
          span: 18
        },
        {
          key: 'workAreaUid',
          label: '所属场站工区',
          type: 'select',
          options: (params) => {
            return params.state.organization.orgFactory
          },
          checkByValue: true,
          clearable: true,
          span: 18
        }
      ]
    },
    startEndStake: {
      name: 'startEndStake',
      title: '添加起讫桩号',
      formParams: {
        lineCode: (params) => {
          return params.state.currentRow.division
            ? params.state.currentRow.division.lineCode
            : 'K'
        },
        startStake: (params) => {
          return params.state.currentRow.division
            ? params.state.currentRow.division.startStake
            : null
        },
        endStake: (params) => {
          return params.state.currentRow.division
            ? params.state.currentRow.division.endStake
            : null
        },
        centerStake: (params) => {
          return params.state.currentRow.division
            ? params.state.currentRow.division.centerStake
            : null
        },
        startEndStake: (params) => {
          return params.state.currentRow.division
            ? params.state.currentRow.division.startEndStake
            : null
        },
        projectNo: (params) => {
          return params.state.currentRow.division
            ? params.state.currentRow.division.projectNo
            : null
        }
      },
      formRules: {
        lineCode: [
          {
            required: true,
            message: '请输入至少一个大写英文字母',
            trigger: 'blur'
          },
          {
            pattern: /^[A-Z]+$/g,
            message: '请输入至少一个大写英文字母',
            trigger: 'blur'
          }
        ],
        centerStake: [
          {
            required: true,
            message: '请输入起始桩号',
            trigger: 'blur'
          },
          {
            pattern: /^\d+(\.\d{1,3})?$/g,
            message: '请输入数字,如果为小数则小数点后保留三位',
            trigger: 'blur'
          },
          {
            validator: (params) => {
              return params.validate.validateStake
            },
            trigger: 'blur'
          }
        ],
        startStake: [
          {
            required: true,
            message: '请输入起始桩号',
            trigger: 'blur'
          },
          {
            pattern: /^\d+(\.\d{1,3})?$/g,
            message: '请输入数字,如果为小数则小数点后保留三位',
            trigger: 'blur'
          },
          {
            validator: (params) => {
              return params.validate.validateStake
            },
            trigger: 'blur'
          }
        ],
        endStake: [
          {
            required: true,
            message: '请输入终止桩号',
            trigger: 'blur'
          },
          {
            pattern: /^\d+(\.\d{1,3})?$/g,
            message: '请输入数字,如果为小数则小数点后保留三位',
            trigger: 'blur'
          },
          {
            validator: (params) => {
              return params.validate.validateStake
            },
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'lineCode',
          label: '线路编号',
          placeholder: '请输入至少一个大写英文字母',
          type: 'input',
          span: 18
        },
        {
          key: 'centerStake',
          label: '中心桩号',
          type: 'input',
          placeholder: '默认由起讫桩号自动计算',
          span: 18,
          disabled: true
        },
        {
          key: 'startStake',
          label: '起始账号',
          type: 'input',
          placeholder: '请输入数字，小数时小数点后保留三位',
          span: 18,
          number: 3
        },
        {
          key: 'endStake',
          label: '终止桩号',
          type: 'input',
          placeholder: '请输入不小于起始桩号的数字',
          span: 18,
          number: 3
        },
        {
          key: 'projectNo',
          label: '工程编号',
          type: 'input',
          placeholder:
            '请输入如桥梁中心桩号K5+600、墩台编号1#墩等工程管理编号，段落编号可不输入默认为起讫桩号',
          span: 18
        }
      ]
    },
    subitemCN: {
      name: 'subitemCN',
      title: '修改分部分项名称',
      formParams: (params) => {
        var formParams = {}
        if (
          params.state.formValues.division &&
          params.state.formValues.division.subitemCNs
        ) {
          params.state.formValues.division.subitemCNs.forEach((item) => {
            formParams[item.codeKey] = item.subitemCode
            formParams[item.nameKey] = item.subitemName
          })
        }
        return formParams
      },
      formRules: (params) => {
        var formRules = {}
        if (
          params.state.formValues.division &&
          params.state.formValues.division.subitemCNs
        ) {
          params.state.formValues.division.subitemCNs.forEach((item) => {
            formRules[item.codeKey] = [
              {
                required: true,
                message: '请输入分部分项编码',
                trigger: 'blur'
              }
            ]
            formRules[item.nameKey] = [
              {
                required: true,
                message: '请输入分部分项名称',
                trigger: 'blur'
              }
            ]
          })
        }
        return formRules
      },
      formData: (params) => {
        var formData = []
        if (
          params.state.formValues.division &&
          params.state.formValues.division.subitemCNs
        ) {
          params.state.formValues.division.subitemCNs.forEach((item) => {
            let code = {}
            let name = {}
            code.key = item.codeKey
            code.label = '分部分项编号' + item.code
            code.type = 'input'
            code.span = 9
            name.key = item.nameKey
            name.label = '分部分项名称' + item.code
            name.type = 'input'
            name.span = 15
            formData.push(code, name)
          })
        }
        return formData
      }
    },
    quantity: quantity,
    structureSize: structureSize
  },
  progressItem: {
    name: 'progressItem',
    componentTypes: [
      'navigate',
      'check',
      'tables',
      'stepForm',
      'drawerTable',
      'dialogForm',
      'dialogTable'
    ],
    detailPage: [
      {
        buttonName: '挂接进度',
        type: 'stepForm',
        name: 'progressItem',
        theme: 'division',
        step: 'progressItemInfo',
        label: '添加形象进度分项',
        pageStatus: 'progress'
      },
      {
        buttonName: '清单挂接',
        type: 'stepForm',
        name: 'progressItem',
        theme: 'division',
        step: 'progressItemInfo',
        label: '添加工程量清单挂接',
        pageStatus: 'listHook'
      },
      {
        buttonName: '复核工程量',
        type: 'dialogTable',
        name: 'quantity',
        expandAll: true
      },
      {
        code: (params) => {
          return params.currentRow && params.currentRow.children
            ? 'listHookInfo'
            : null
        },
        type: 'expand',
        name: 'progressItem'
      },
      {
        code: (params) => {
          return params.currentRow && params.currentRow.children
            ? 'concealedWorkInfo'
            : null
        },
        type: 'drawerTable',
        name: 'concealedWork',
        pageStatus: 'list'
      }
    ],
    headButtons: setCheckButtons(['挂接进度', '复核工程量']),
    getListFun: 'division/getSubitemInfo',
    deleteFun: () => {
      return (row) => {
        return row.children
          ? 'progress/deleteProgressItem'
          : 'billOfQuantities/deleteBillOfQuantities'
      }
    },
    outListHeight: 230,
    tagInfo: (params) => {
      return (
        '当前分项为' +
        (params.state.currentRow.division
          ? params.state.currentRow.division.subitemName + '，'
          : '') +
        '已根据系统默认关联规则添加的相关形象进度分项，可根据实际情况增删进度分项挂接。点击“复核工程量”按钮可批量修改当前列表中形象进度及清单复核工程量。'
      )
    },
    rowData: (params) => {
      return params.state.division.progressItemType
    },
    columns: [
      {
        prop: 'codeName',
        label: '\xa0\xa0\xa0进度分项&&清单细目',
        align: 'left',
        width: '300px'
      },
      { prop: 'unit', label: '单位' },
      { prop: 'quantity', label: '工程数量' },
      {
        prop: 'listHookInfo',
        label: '清单挂接信息&&图纸信息',
        drillDown: true
      },
      {
        prop: 'concealedWorkInfo',
        label: '隐蔽工程工序&&备注信息',
        width: '500px',
        overflow: false,
        drillDown: true,
        tooltip: () => {
          return (row) => {
            return row.children ? { tipValue: '点击查看隐蔽工程详情' } : null
          }
        }
      },
      {
        label: '操作',
        width: '180px',
        buttons: () => {
          return (row) => {
            return row.children
              ? setTableButtons(['清单挂接', '删除'])
              : setTableButtons(['删除'])
          }
        }
      }
    ],
    formParams: (params) => {
      var formParams = params.formValues
        ? JSON.parse(JSON.stringify(params.formValues))
        : {}
      formParams.progressItemTypeUid =
        params.pageStatus === 'listHook' && params.currentRow
          ? [params.currentRow.progressItemTypeUid]
          : []
      formParams.progressUid =
        params.pageStatus === 'listHook' && params.currentRow
          ? params.currentRow.uid
          : null
      formParams.progressItems =
        params.pageStatus === 'listHook' && params.currentRow
          ? [params.currentRow]
          : []
      formParams.listHook = []
      formParams.concealedWorks = []
      return formParams
    },
    formRules: {
      progressItemTypeUid: [
        {
          type: 'array',
          required: true,
          message: '请至少选择一个进度分项',
          trigger: 'change'
        }
      ],
      listHook: [
        {
          type: 'array',
          required: (params) => {
            return params.pageStatus === 'listHook' ? true : false
          },
          message: '请至少选择一个工程量清单',
          trigger: 'change'
        }
      ]
    },
    formData: {
      card: '分部分项工程信息',
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: [
        {
          key: 'subitemCode',
          label: '分部分项编码',
          type: 'input',
          disabled: true
        },
        {
          key: 'subitemName',
          label: '分部分项名称',
          type: 'input',
          disabled: true
        },
        {
          key: 'subitemLevel',
          label: '分部分项级别',
          type: 'select',
          options: (params) => {
            return params.dictionarys.subitemLevel
          },
          disabled: true,
          checkByValue: true
        },
        {
          key: 'subitemType',
          label: '分部分项类型',
          type: 'input',
          disabled: true
        },
        {
          key: 'progressItemTypeUid',
          label: '进度分项类型',
          type: 'cascader',
          options: (params) => {
            return params.dictionarys.progressItemType
          },
          placeholder: '根据分部分项工程类型选项选择对应的进度分项类型',
          multiple: true,
          emitPath: false,
          showAllLevels: false,
          checkByValue: true,
          disabled: (params) => {
            return params.pageStatus === 'listHook' ? true : false
          }
        },
        {
          key: 'listHook',
          label: '清单工程量',
          type: 'select',
          options: (params) => {
            let listHook = []
            if (params.pageStatus === 'listHook') {
              listHook = params.getters[
                'billOfQuantities/billOfContract'
              ].filter((list) => {
                list.value = list.uid
                list.label = list.codeName + '\xa0\xa0' + list.unit
                return list.contractQuantity || list.contractQuantity === 0
              })
            } else {
              listHook = params.state.division.listHook
            }
            return listHook
          },
          placeholder: '根据进度分项选项变化自动按规则生成',
          multiple: true,
          valueKey: 'value'
        },
        {
          key: (params) => {
            return params.pageStatus === 'listHook' ? null : 'concealedWorks'
          },
          label: '隐蔽工程工序',
          type: 'select',
          options: (params) => {
            return params.state.division.concealedWorks
          },
          placeholder: '根据进度分项选项变化自动按规则生成',
          multiple: true,
          valueKey: 'value'
        }
      ]
    },
    quantity: quantity,
    concealedWork: {
      name: 'concealedWork',
      title: (params) => {
        return params.pageStatus === 'list'
          ? '隐蔽工程列表'
          : params.pageStatus === 'add'
          ? '新增隐蔽工程'
          : '编辑隐蔽工程'
      },
      deleteFun: 'concealedWork/deleteConcealedWork',
      addFun: 'concealedWork/addConcealedWork',
      editFun: 'concealedWork/editConcealedWork',
      getListFun: 'division/getSubitemInfo',
      getParentFun: 'division/getSubitemInfo',
      headButtons: setCheckButtons(['新增']),
      detailPage: [
        {
          buttonName: '新增',
          name: 'concealedWork',
          type: 'dialogForm'
        },
        {
          buttonName: '编辑',
          name: 'concealedWork',
          type: 'dialogForm',
          checkType: 'useRowData'
        },
        {
          buttonName: '复制',
          name: 'concealedWork',
          type: 'dialogForm'
        }
      ],
      indexColumn: true,
      rowData: (params) => {
        const progressItem = params.state.division.progressItemType.find(
          (item) => item.uid === params.state.currentRow.progressItem.uid
        )
        return progressItem ? progressItem.concealedWorks : []
      },
      columns: [
        {
          label: '隐蔽工程类型',
          prop: 'concealedWork'
        },
        {
          label: '验收内容',
          prop: 'acceptanceContents',
          width: '700px'
        },
        {
          label: '作业批次',
          prop: 'workBatchName'
        },
        {
          label: '作业完成标志（按形象进度%）',
          prop: 'workFinishFlag'
        },
        {
          label: '操作',
          buttons: setTableButtons(['编辑', '删除'])
        }
      ],
      addArray: true,
      formParams: {
        orgUid: (params) => {
          return params.orgValue
        },
        subitemUid: (params) => {
          return params.state.division.subitemInfo.uid
        },
        progressUid: (params) => {
          return params.state.currentRow.progressItem.uid
        },
        concealedUid: '',
        concealedWork: '',
        acceptanceContents: '',
        workBatchName: '',
        workFinishFlag: null
      },
      formRules: {
        concealedWork: [
          {
            required: true,
            message: '隐蔽工程类型不能为空',
            trigger: 'blur'
          }
        ],
        workFinishFlag: [
          {
            required: true,
            message: '作业完成标志不能为空',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'concealedWork',
          label: '隐蔽工程类型',
          type: 'select',
          options: (params) => {
            return params.state.currentRow.progressItem.concealedWorks
          },
          valueKey: 'value',
          formKeys: ['concealedWork', 'concealedUid', 'acceptanceContents'],
          span: 18
        },
        {
          key: 'acceptanceContents',
          label: '验收内容',
          type: 'input',
          placeholder: '请输入隐蔽工程类型验收的主要内容',
          span: 18
        },
        {
          key: 'workBatchName',
          label: '作业批次名称',
          type: 'input',
          placeholder:
            '分多批次作业时，请输入批次编号或说明，如第一节、第一层等',
          span: 18
        },
        {
          key: 'workFinishFlag',
          label: '作业完成标志',
          type: 'input',
          placeholder:
            '请输入形象进度完成数值比例，作为判断隐蔽工程是否完成的标志',
          inputButton: '%',
          number: true,
          span: 18
        }
      ]
    }
  }
}

export default division
